import type { HttpGet, HttpRequest } from '@/shared/infra/http'
import type { MemberContext, LoadMemberContext, LoadMemberContextParams } from '@/shared/domain'

export class SupabaseLoadMemberContextRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: LoadMemberContext = async (params) => {
    const query = buildQuery(params)
    const request: HttpRequest<never> = {
      url: `/members/me/context${query}`,
    }
    return this.httpClient.get<MemberContext>(request)
  }
}

function buildQuery(params?: LoadMemberContextParams): string {
  if (!params) return ''
  const search = new URLSearchParams()
  if (params.selectedOrgId !== undefined) {
    search.set('selectedOrgId', params.selectedOrgId)
  }
  if (params.includeOrgDetails !== undefined) {
    search.set('includeOrgDetails', String(params.includeOrgDetails))
  }
  if (params.includeLegalDocs !== undefined) {
    search.set('includeLegalDocs', String(params.includeLegalDocs))
  }
  if (params.includeOrgStatus !== undefined) {
    search.set('includeOrgStatus', String(params.includeOrgStatus))
  }
  const qs = search.toString()
  return qs ? `?${qs}` : ''
}
